module.exports = __webpack_public_path__ + "static/assets/4bfa4db4f366febfd0a820b1655623dc.png";